import Badge from "@/common/components/Badge";
import Box from "@/common/components/Box";
import MaskedTextField from "@/common/components/MaskedTextField";
import TextField from "@/common/components/TextField";
import { customUnitMask } from "@/common/constants/masks.constant";
import { CardDetailsData } from "@/common/types/cards/details.type";
import { ProductData } from "@/common/types/product.type";
import { formatCurrency } from "@/common/utils/formatters";
import { FileBoxIcon, InfoIcon } from "lucide-react";
import { options as unitForQuantity } from '@/common/constants/unitForQuantityOptions.contant';

interface CardCurrentLimitValuesProps {
  cardDetails?: CardDetailsData;
  product: ProductData | undefined;
  cardCurrentLimits: any;
  cardCurrentLimitsIsPending: boolean;
}

const CardCurrentLimitValues = ({
  cardDetails,
  product,
  cardCurrentLimits,
  cardCurrentLimitsIsPending,
}: CardCurrentLimitValuesProps) => {
  return (
    <div className="flex flex-col gap-4 sm:gap-6 px-4 sm:p-0 sm:pr-2">
      {product && cardDetails && (
        <>
          {!cardCurrentLimitsIsPending && cardCurrentLimits ? (
            <Box className="flex flex-col gap-2 p-4 sm:p-6">
              <p>Valores liberados</p>

              <div className="flex gap-2">
                <div>
                  <InfoIcon strokeWidth={1} color="var(--warning)" />
                </div>

                <div className="flex flex-col gap-0.5">
                  <p className="text-xs">Os valores exibidos são calculados conforme todas as limitações e créditos garantidos a filial.</p>
                  <p className="text-xs font-light italic">Caso existam ambos Quantidade e Valor total, vale o que for atingido primeiro.</p>
                </div>
              </div>

              <Box className="flex flex-col gap-3 p-4 sm:p-6">
                <Badge
                  Icon={() => <FileBoxIcon strokeWidth={1} />}
                  text={product?.display_name}
                />

                <div className="flex flex-col gap-2">
                  {cardCurrentLimits?.quantity_limit_for_display !== null && (
                    <div className="grow">
                      <MaskedTextField
                        label="Quantidade"
                        mask={customUnitMask(
                          unitForQuantity.find((unit) => unit.value === product.unit_for_quantity)?.symbol || '',
                        )}
                        value={cardCurrentLimits?.quantity_limit_for_display?.toString()}
                        disabled
                      />
                    </div>
                  )}

                  {cardCurrentLimits?.quantity_limit_for_display !== null && cardCurrentLimits?.credit_limit_for_display !== null && (
                    <div className="flex items-center justify-center">
                      <p>Ou</p>
                    </div>
                  )}

                  {cardCurrentLimits?.credit_limit_for_display !== null && (
                    <div className="grow">
                      <TextField
                        label="Valor total"
                        value={formatCurrency(Number(cardCurrentLimits?.credit_limit_for_display))}
                        disabled
                      />
                    </div>
                  )}
                </div>
              </Box>
            </Box>
          ) : (cardCurrentLimitsIsPending) ? (
            <Box className="h-[280px] flex items-center justify-center">
              <div className="w-6 h-6 border-4 border-dashed rounded-full animate-spin border-blue-800 mb-1 mr-1" />
            </Box>
          ) : (
            <></>
          )}
        </>
      )}
    </div>
  );
}

export default CardCurrentLimitValues;
